export const globalGetters = {
    isMobile: (state) => state.serverDetectMobile,
    canHandleWebp: (state) => state.clientCanHandleWebp,
    getLocations: (state) => state.locations,
    getCurrentRegion: (state) => state.currentRegion,
    hasPendingAjaxRequest(state) {
        return state.numberOfAjaxCallPending > 0;
    },
};
